



























import { Component, Vue, Prop } from 'vue-property-decorator'
import config from '@/config'

@Component
export default class Address extends Vue {
  @Prop() need_receiver: boolean
  @Prop() products
  @Prop() receiver_info
  loading: boolean = true
  receiver: any
  get address() {
    return `${this.receiver.province_name}${this.receiver.city_name}${this
      .receiver.district_name || ''}${this.receiver.address}`
  }
  created() {
    this.loading = true
    this.showAddress()
  }

  async toAddressList() {
    let { act_id, channel_id, slt, receiver_id } = this.$route.query
    let _head = location.origin
    if (_head.indexOf('localhost') > -1) {
      _head = 'http://m.ivydad.com.cn'
    }

    let _redirect = `${window.location.origin}${
      window.location.pathname
    }?act_id=${act_id}&channel_id=${channel_id}&slt=${slt}&sku_id=${
      this.products[0].id
    }`
    window.location.replace(
      `${_head}/center/address/addressList?mode=select${
        receiver_id ? '&receiverId=' + receiver_id : ''
      }&redirect=` + encodeURIComponent(_redirect)
    )
  }
  async showAddress() {
    this.loading = false
    // receiver就是接收的传回来的地址
    this.receiver = this.receiver_info
  }
}
